import StyledLink from '../StyledLink'
import { ENVIRONMENTS } from '../routes'
import type { Props } from '../types'

interface Params {
  environmentId: number
}

const LinkToEnvironment = ({
  children,
  environmentId,
  isHyperlink
}: (Props & Params)) => {
  const toUrl = '/' + ENVIRONMENTS + '/' + environmentId + '/edit'

  return (
    <StyledLink
      isHyperlink={isHyperlink}
      to={toUrl}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToEnvironment
